import React, { useRef, useEffect, useState } from 'react';
import { SplideSlide } from '@splidejs/react-splide';
import { Box, SwatchPicker, Optional, Image } from '@honda-canada/design-system-react';
import themeStyles from './ColorSwatchCarousel.styles';
import CarouselSlider from '../../../CarouselSlider';
import ColorUpChargePrice from './ColorUpChargePrice';
const ColorSwatch = themeStyles.apply(Box, 'ColorSwatch');
const MAX_ITEM_WIDTH = 85;
const ColorSwatchCarousel = ({ swatchTestId, swatches, selectedColor, handleClick, onSliderArrowClick, }) => {
    var _a;
    const containerRef = useRef(null);
    const [colorsPerPage, setColorsPerPage] = useState(0);
    useEffect(() => {
        var _a;
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) > 0) {
            const containerWidth = containerRef.current.offsetWidth;
            setColorsPerPage(Math.floor(containerWidth / MAX_ITEM_WIDTH));
        }
    }, [(_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth]);
    const pages = colorsPerPage > 0 ? Math.ceil(swatches.length / colorsPerPage) : 0;
    const hasPagination = pages > 1;
    return (React.createElement(Box, { ref: containerRef },
        React.createElement(Optional, { when: colorsPerPage },
            React.createElement(CarouselSlider, { length: pages, hasPagination: hasPagination, paginationControlWithShadow: false, centerAlign: false, onSliderArrowClick: onSliderArrowClick, splideOptions: {
                    padding: { left: '0', right: '0' },
                    perPage: colorsPerPage,
                    perMove: colorsPerPage,
                    width: `${MAX_ITEM_WIDTH * colorsPerPage}px`,
                } }, () => swatches.map(({ colorUpCharge, key, name, color, image }) => {
                const { price, payment, paymentFrequency, tooltipLabel } = colorUpCharge || {};
                const swatch = color ? { name, color } : { name, image: React.createElement(Image, { ...image }) };
                return (React.createElement(SplideSlide, { key: key },
                    React.createElement(ColorSwatch, { "data-testid": `cy-${swatchTestId}-swatch-${name}` },
                        React.createElement(SwatchPicker, { swatch: swatch, onClick: () => handleClick(key), "data-testid": `cy-color-${name}`, icon: selectedColor === key && 'checkmark' }),
                        React.createElement(Optional, { when: price },
                            React.createElement(ColorUpChargePrice, { price: price, payment: payment, paymentFrequency: paymentFrequency, tooltipLabel: tooltipLabel })))));
            })))));
};
export default ColorSwatchCarousel;
